export default {
  hint: "Aggregated catalogue statistics (starter dashboard).",
  relation: "Relations",
  total: "Total records",
  updated: "Updated {{date}}",
  countsTitle: "Catalogue entities",
  byYear: "Editions by year",
  topPublishers: "Publishers",
  topSubjects: "Subjects",
  topPrizes: "Prizes",
  empty: "No statistics collected yet.",
}
